import CheckboxRenderer from "@wielink/datatables/Renderers/CheckboxRenderer.js";
import DateRenderer from "@wielink/datatables/Renderers/DateRenderer.js";
import DateTimeRenderer from "@wielink/datatables/Renderers/DateTimeRenderer.js";
import ShortDateRenderer from "@wielink/datatables/Renderers/ShortDateRenderer.js";
import ShortDatetimeRenderer from "@wielink/datatables/Renderers/ShortDatetimeRenderer.js";
import TimeRenderer from "@wielink/datatables/Renderers/TimeRenderer.js";
import ValutaRenderer from "@wielink/datatables/Renderers/ValutaRenderer.js";
import ActionRenderer from "@wielink/datatables/Renderers/ActionRenderer";
import PriceRenderer from "@wielink/datatables/Renderers/PriceRenderer";
import TextRenderer from "@wielink/datatables/Renderers/TextRenderer";
import ReorderRenderer from "@wielink/datatables/Renderers/ReorderRenderer";

export default {
    'checkbox': CheckboxRenderer,
    'date': DateRenderer,
    'dateTime': DateTimeRenderer,
    'shortDate': ShortDateRenderer,
    'shortDatetime': ShortDatetimeRenderer,
    'timeRenderer': TimeRenderer,
    'valutaRenderer': ValutaRenderer,
    'actions': ActionRenderer,
    'price': PriceRenderer,
    'text': TextRenderer,
    'reorder': ReorderRenderer,
}
